import React from 'react';

const LoadSpinner = () => (
<div className="d-flex justify-content-center text-secondary">
  <div className="spinner-border" role="status">
    <span className="sr-only">Loading...</span>
  </div>
</div>
);

export default LoadSpinner;